import { precision } from "./precision.js";
import operation from "./operation.js";
export var union = function(geom) {
    for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        moreGeoms[_key - 1] = arguments[_key];
    }
    return operation.run("union", geom, moreGeoms);
};
export var intersection = function(geom) {
    for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        moreGeoms[_key - 1] = arguments[_key];
    }
    return operation.run("intersection", geom, moreGeoms);
};
export var xor = function(geom) {
    for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        moreGeoms[_key - 1] = arguments[_key];
    }
    return operation.run("xor", geom, moreGeoms);
};
export var difference = function(geom) {
    for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        moreGeoms[_key - 1] = arguments[_key];
    }
    return operation.run("difference", geom, moreGeoms);
};
export var setPrecision = precision.set;
